module.exports = __webpack_public_path__ + "img/04d.4f656696.svg";